// extracted by mini-css-extract-plugin
module.exports = {"root":"AdsBlock_root__7GrJI","wrapper":"AdsBlock_wrapper__mrs_8","ads":"AdsBlock_ads__2dzv1","heading":"AdsBlock_heading__A9q7r","row":"AdsBlock_row__ni_V_"};